import React from "react";
import { Link } from "react-router-dom";
import { imageBasePath } from "../../../Utils/config";
import Stepper from "../../Stepper/Stepper";

const MembershipSidebar = ({
  steps,
  activeStep,
  subActiveStep,
  setActiveStep,
  setSubActiveStep,
  isOpen,
  setIsOpen,
}) => {
  return (
    <div className="h-screen bg-[#F5F5F5]">
      <div className="block lg:hidden">
        <div
          onClick={() => setIsOpen(!isOpen)}
          className={`flex justify-center items-center cursor-pointer py-4`}
        >
          <button
            type="button"
            class="text-white bg-gold3 hover:bg-gold4 focus:ring-4 focus:outline-none ring-gold2 focus:ring-gold-2 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center mr-2"
          >
            <img
              src={imageBasePath + `${isOpen ? "cartclose.png" : "cart.png"}`}
              alt="cart"
            />
          </button>
        </div>
      </div>
      <div
        className={`h-[80vh] lg:pl-18 pt-20 ${
          isOpen ? "pl-1 md:pl-12" : "pl-1 lg:pl-12"
        }`}
      >
        <Stepper
          steps={steps}
          activeStep={activeStep}
          subActiveStep={subActiveStep}
          setActiveStep={setActiveStep}
          setSubActiveStep={setSubActiveStep}
        />
      </div>
      <div className="h-[20vh] flex items-center pl-10 sm:pl-20">
        <p className="w-[217px] h-[32px] font-font-Titillium font-light text-[14px] leading-[16.8px] tracking-[0.025em]">
          If you have any questions about this form, please{" "}
          <Link
            to="/contactUs"
            className="font-font-Titillium font-semibold text-[14px] leading-[16.8px] tracking-[0.025em]"
          >
            Contact Us
          </Link>
        </p>
      </div>
    </div>
  );
};

export default MembershipSidebar;
